<script>
import TablePage from '../../../../../../components/table_page';

export default {
  extends: TablePage,
  props: {
    propsObj: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      requestUrl: '/mdm/mdmPositionUnderlingController/findParentPositionList',
      params: {
        enableStatus: '009',
        excludeChildPositionCodeList: this.propsObj.selectRow.map((a) => a.underlingPositionCode) || [],
      },
      configs: {
        formConfig: {
          titleWidth: 100,
          titleAlign: 'right',
          item: [],
        },
        toolBarConfig: [
          // {
          //   name: '确认',
          //   buttonType: '0',
          //   buttonCode: 'submitAssociated',
          // },
        ],
        columns: [],
        tableConfig: {},
      },
    };
  },
  created() {
    console.log('peizhi', this.propsObj);
    this.getConfigList('mdm_position_information_associated_select_position');
  },
  mounted() {
  },
  methods: {
    // 重写 让其不被覆盖
    setButton() {

    },
    // 重新 覆盖 按钮事件

    buttonClick({ val }) {
      if (val.buttonCode === 'submitAssociated') {
        if (this.selectRow.length > 0) {
          this.$emit('submit', this.selectRow);
        } else {
          this.$message('请勾选');
        }
      }
    },
  },

};
</script>

<style scoped lang="less">
  .associated_customer{
    /*height: 50vh;*/
  }

</style>
